var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 100,
    viewBox: "0 0 360 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 36,
    fill: "#ffffff",
    stroke: "#1e90ff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,-24 -4,4 0,2 4,4",
    fill: "#1e90ff"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 63,
    fontFamily: "Arial, sans-serif",
    fontSize: 42,
    fill: "#1e90ff",
    fontWeight: 700,
    letterSpacing: 1
  }, "\n    LifeCompass\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.991da559e471e236a6efee587818f743.svg";
export { ForwardRef as ReactComponent };